<div class="perf-summary-card" role="region" aria-labelledby="perfSummaryTitle">
  <div class="header">
    <div class="title-row">
      <emerald-icon [icon]="'assessment'" [type]="'outlined'" [variant]="'icon'"></emerald-icon>
      <h3 class="title" id="perfSummaryTitle">
        <button type="button" class="title-button" (click)="openDetails()">
          Performance Rating
        </button>
      </h3>
      <emerald-icon
        icon="open_in_new"
        color="#6b7280"
        role="button"
        tabindex="0"
        class="expand-icon"
        (click)="openDetails()"
        (keydown.enter)="openDetails()"
        (keydown.space)="openDetails()"
      ></emerald-icon>
      <select
        class="year-select"
        aria-label="Year"
        [ngModel]="activeYear"
        (ngModelChange)="onYearChange($event)"
      >
        <option *ngFor="let y of yearOptions" [ngValue]="y.value">{{ y.label }}</option>
      </select>
    </div>
    <div class="quarter-chips" role="tablist" aria-label="Quarter">
      <button
        *ngFor="let chip of quarterChips"
        type="button"
        role="tab"
        class="chip"
        [class.chip--active]="activeQuarter === chip.value"
        [attr.aria-selected]="activeQuarter === chip.value"
        (click)="onQuarterChipClick(chip.value)"
      >
        {{ chip.label }}
      </button>
    </div>
  </div>

  <ng-container *ngIf="!loading && !loadError">
    <div class="chart-wrapper">
      <canvas
        baseChart
        [datasets]="chartDatasets"
        [labels]="chartLabels"
        [options]="chartOptions"
        [type]="chartType"
      ></canvas>
    </div>

    <div class="footer">
      <span class="footer__summary">
        <strong>{{ ratedCount }}</strong> of <strong>{{ totalCwr }}</strong> rated
        <span class="footer__pct" *ngIf="totalCwr > 0">· {{ ratedPercent() }}%</span>
      </span>
      <span class="footer__unrated" *ngIf="unratedCount > 0">
        {{ unratedCount }} unrated
      </span>
    </div>
  </ng-container>

  <div class="loading" *ngIf="loading">Loading…</div>
  <div class="error" *ngIf="loadError">Failed to load</div>
</div>
